import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UserProfile from "./UserProfile";
import MyMessages from "./MyMessages";
import Home from "./Home";
import "bootstrap/dist/css/bootstrap.min.css";
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import firebase from 'firebase/compat/app';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Form, Button, Modal } from 'react-bootstrap';

const firebaseConfig = {
  apiKey: "AIzaSyCYL4jdQ4luRJuwBSHVqfBuJV4J7Pt_UcU",
  authDomain: "energyvoo.firebaseapp.com",
  projectId: "energyvoo",
  storageBucket: "energyvoo.appspot.com",
  messagingSenderId: "459716366735",
  appId: "1:459716366735:web:c167d67922ab6990b67bfa",
  measurementId: "G-HWNDGWFXZH"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);




function App() {

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [userPhoto, setUserPhoto] = useState('');
  const [showMysub, setShowMySub] = useState(false);
  const [show, setShow] = useState(false);

  const auth = getAuth();
  const firestore = getFirestore();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        setIsSignedIn(true);
        setUserName(user.displayName);
        setUserPhoto(user.photoURL);
      } else {
        setIsSignedIn(false);
        setUserPhoto('');
        setUserName('')
      }
    });
  }, []);

  const signInWIthGoogle = async () => {

    // mixpanel.track('signIn', {
    //   message: "signin button clicked"
    // })

    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      console.log(result);
      const guser = result.user.displayName;
      const userEmail = result.user.email;
      const userPhoto = result.user.photoURL;
      const userID = result.user.uid; // Get the user ID
      console.log(guser);
  
      setUserName(guser);
      setUserPhoto(result.user.photoURL);
      setIsSignedIn(true);
  
      // Check if user document exists in 'users' collection
      const userDocRef = doc(firestore, 'earthusers', userID);
      const userDocSnapshot = await getDoc(userDocRef);
  
      if (!userDocSnapshot.exists()) {
        // Create the user document if it doesn't exist
        await setDoc(userDocRef, {
          displayName: guser,
          photoURL: userPhoto,
          userId: userID,
          email: userEmail,
          location: 'Earth'
          // Add other user details here if needed
        });
        console.log("User document created");
      } else {
        console.log("User document already exists");
      }
  
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...
    } catch (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.error("Error during sign-in:", error);
      // ...
    }
  };

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        setIsSignedIn(false);
        setUserName('');
        setUserPhoto('');
      })
      .catch((error) => {
        console.error("Error during sign-out:", error);
      });
  };

  const handleShowMySub = () => {
    // mixpanel.track('mysubsfromup', {
    //   // message: "card clicked while signed in"
    // })
    setShowMySub(true);
  }


  return (
    <div className="App">
    {/* <div style={{ flex: 1 }} className="container" > */}
    <div className="container-fluid p-0" >
      <nav bg="dark" className="navbar navbar-expand navbar-dark" style={{"padding":"0px", margin:0}} >
          <a href="https://www.ToMotherEarth.com" className="navbar-brand" style={{"color": '#748f80', marginLeft:15}} > 
          {/* <img src="./logo.png" width="25" alt="logo" />   */}
          ToMotherEarth
          </a>
          
          <div class="collapse navbar-collapse" id="toggleMobileMenu">
            <ul class="navbar-nav">
            </ul>
          </div>
        
      
          <span class="navbar-text">
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav mr-auto">
              {/* display profile photo here */}
              <li className="nav-item">
              <a onClick={isSignedIn ? () => (window.location.href = 'https://www.ToMotherEarth.com/profile') : handleShowMySub }>
              {/* <a onClick={show ? handleClose : handleShow}> */}
                <img
                  src={isSignedIn && userPhoto ? userPhoto : "./account.png"}
                  alt={userName || "placeholder"}
                  style={{ width: 35, height: 35, borderRadius: '50%' }}
                />
              </a>
              </li>
            </ul>
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <a onClick={show ? handleClose : handleShow} className="nav-link" style={{ color: '#CCCCCC', margin: 5 }}>
                    <img src={show ? "./close.png" : "./menu.png"} width="35" alt="menu" />
                  </a>
                </li>
              </ul>
          </div>
          
          </span> 
          
          
      </nav>
  </div>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/messages" element={<MyMessages />} />
      </Routes>
    </Router>

    <Offcanvas style={{height:280}} scroll={true} placement={'top'} show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <a href="https://www.ToMotherEarth.com" class="navbar-brand" style={{"color": '#748f80', margin:5}} > ToMotherEarth  </a>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <Button variant={'primary'} 
              style={{ backgroundColor: '#2196F3', borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }} 
              className="w-100" 
              onClick={isSignedIn ? () => (window.location.href = 'https://www.ToMotherEarth.com/messages') : handleShowMySub }              >
              My Messages
            </Button>
            <Button variant={'primary'} 
              style={{ backgroundColor: '#2196F3', borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }} 
              className="w-100" 
              onClick={isSignedIn ? () => (window.location.href = 'https://www.ToMotherEarth.com/profile') : handleShowMySub }              >
              My Profile
            </Button>
            <Button variant={isSignedIn ? 'light':'danger'} 
              style={{ borderColor: '#C7BEBE', margin: 4, marginTop: 8, height: 50, borderRadius: 100, fontSize: 20 }} 
              className="w-100" 
              onClick={isSignedIn ? handleSignOut : signInWIthGoogle}>
                {isSignedIn ? `Sign Out (${userName})` : 'Sign In with Google'}
            </Button>
        </Offcanvas.Body>
    </Offcanvas>
  </div>
  );
}

export default App;
